import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = { class: "widget shadow-100 pb-2" }
const _hoisted_4 = { class: "container-full-2 my-5" }
const _hoisted_5 = { class: "s7" }
const _hoisted_6 = { class: "font-semibold mt-4" }
const _hoisted_7 = { class: "text-sm text-grey-500" }
const _hoisted_8 = { class: "s13 flex justify-content-right" }
const _hoisted_9 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_10 = { class: "form-field-floating reactive sm" }
const _hoisted_11 = { class: "form-field-floating sm" }
const _hoisted_12 = { class: "form-field-floating sm" }
const _hoisted_13 = { class: "table separator skin1" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex align-items-center" }
const _hoisted_18 = { class: "position-relative" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 1,
  class: "size-md rounded-100 mr-3 bg-grey-200 flex align-items-center justify-content-center"
}
const _hoisted_21 = { class: "text-xs" }
const _hoisted_22 = {
  key: 2,
  class: "badge-notification"
}
const _hoisted_23 = { class: "text-xs text-grey-500" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "text-xs text-grey-500" }
const _hoisted_26 = {
  key: 1,
  class: "text-grey-500"
}
const _hoisted_27 = {
  key: 0,
  class: "text-danger text-xs"
}
const _hoisted_28 = ["onClick"]

import { computed, onMounted, ref, reactive, onUnmounted } from 'vue';
    import { useRouter } from 'vue-router';
    import chatService, { type ChatConversation } from '@/services/chatService';
    import { formatDate } from '../../utils';
    import { useNotificationStore } from '@/stores/notificationStore';
    import { onEvent, offEvent } from '@/config/socket';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceClientListView',
  setup(__props) {

    const router = useRouter();
    const notificationStore = useNotificationStore();
    const errorMessage = ref('');
    const loading = ref(false);
    const conversationsList = ref<ChatConversation[]>([]);
    const selectedItem = ref<ChatConversation | null>(null);
    const showFilters = ref(false);
    
    const filters = reactive({
        statut: '',
        type: '',
        search: '',
    });

    // Callback pour les nouveaux messages (rafraîchir la liste)
    const handleNewMessage = (data: any) => {
        console.log('[ServiceClientList] Nouveau message reçu:', data);
        // Rafraîchir la liste
        doListConversations();
    };

    // Obtenir le nombre de messages non lus pour une conversation
    function getUnreadCount(conversationId: number): number {
        return notificationStore.getUnreadForConversation(conversationId);
    }

    onMounted(() => {
        doListConversations();
        // Rafraîchir les compteurs
        notificationStore.fetchUnreadCount();
        // Écouter les nouveaux messages
        onEvent('new.message.admin', handleNewMessage);
    });

    onUnmounted(() => {
        offEvent('new.message.admin', handleNewMessage);
    });

    async function doListConversations() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const params: any = {};
            if (filters.statut) params.statut = filters.statut;
            if (filters.type) params.type = filters.type;
            if (filters.search) params.search = filters.search;
            params.sortColumn = 'updated_at';
            params.sortDir = 'desc';
            
            conversationsList.value = await chatService.getConversations(params);
        } catch(error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    function doSelectItem(item: ChatConversation) {
        selectedItem.value = item;
    }

    function doUnselectItem() {
        selectedItem.value = null;
    }

    function goToConversation(conversationId: number) {
        router.push(`/app/service-client/${conversationId}`);
    }

    function getStatutBadgeClass(statut: string) {
        switch(statut) {
            case 'open':
                return 'badge-success';
            case 'closed':
                return 'badge-grey';
            case 'pending':
                return 'badge-warning';
            default:
                return 'badge-grey';
        }
    }

    function getStatutLabel(statut: string) {
        switch(statut) {
            case 'open':
                return 'Ouvert';
            case 'closed':
                return 'Fermé';
            case 'pending':
                return 'En attente';
            default:
                return statut;
        }
    }

    function getTypeLabel(type: string) {
        const types: Record<string, string> = {
            'general': 'Général',
            'reclamation': 'Réclamation',
            'remboursement': 'Remboursement',
            'compte': 'Problème compte',
            'carte': 'Carte',
            'autre': 'Autre',
        };
        return types[type] || type;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, [
                _cache[6] || (_cache[6] = _createTextVNode("Service Client ", -1)),
                _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(conversationsList.value.length) + ")", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter", { active: showFilters.value }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showFilters.value = !showFilters.value))
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("img", {
                  src: "/icons/icon-filter.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1),
                _createElementVNode("span", null, "Options", -1)
              ]))], 2)
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["filter-set-area", { active: showFilters.value }])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-input",
                    name: "search",
                    id: "search",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.search) = $event)),
                    placeholder: "Rechercher...",
                    onKeyup: _withKeys(doListConversations, ["enter"])
                  }, null, 544), [
                    [_vModelText, filters.search]
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("label", { for: "search" }, "Recherche (nom, email, téléphone)", -1))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-input-select",
                    name: "statut",
                    id: "statut",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.statut) = $event))
                  }, [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("option", { value: "" }, "Tous les statuts", -1),
                    _createElementVNode("option", { value: "open" }, "Ouvert", -1),
                    _createElementVNode("option", { value: "closed" }, "Fermé", -1),
                    _createElementVNode("option", { value: "pending" }, "En attente", -1)
                  ]))], 512), [
                    [_vModelSelect, filters.statut]
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("label", { for: "statut" }, "Statut", -1))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-input-select",
                    name: "type",
                    id: "type",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.type) = $event))
                  }, [...(_cache[11] || (_cache[11] = [
                    _createStaticVNode("<option value=\"\">Tous les types</option><option value=\"general\">Général</option><option value=\"reclamation\">Réclamation</option><option value=\"remboursement\">Remboursement</option><option value=\"compte\">Problème compte</option><option value=\"carte\">Carte</option><option value=\"autre\">Autre</option>", 7)
                  ]))], 512), [
                    [_vModelSelect, filters.type]
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("label", { for: "type" }, "Type", -1))
                ]),
                _createElementVNode("button", {
                  class: "btn black normal justify-content-center mx-0 btn-filtre",
                  onClick: doListConversations
                }, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("img", {
                    src: "/icons/icon-search.svg",
                    class: "btn-icon",
                    alt: ""
                  }, null, -1),
                  _createElementVNode("span", null, "Rechercher", -1)
                ]))]),
                _createElementVNode("button", {
                  class: "btn white2 normal justify-content-center mx-0 btn-filtre",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {filters.search = ''; filters.statut = ''; filters.type = ''; doListConversations()})
                }, [...(_cache[14] || (_cache[14] = [
                  _createElementVNode("span", null, "Réinitialiser", -1)
                ]))])
              ])
            ], 2)
          ]),
          _createElementVNode("table", _hoisted_13, [
            _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Utilisateur"),
                _createElementVNode("th", null, "Type"),
                _createElementVNode("th", null, "Statut"),
                _createElementVNode("th", null, "Dernier message"),
                _createElementVNode("th", null, "Messages"),
                _createElementVNode("th", null, "Date"),
                _createElementVNode("th", { class: "flex-right" }, "Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("td", { colspan: "7" }, [
                      _createElementVNode("div", { class: "text-center text-grey-700" }, "Chargement...")
                    ], -1)
                  ]))]))
                : (conversationsList.value.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("td", { colspan: "7" }, [
                        _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucune conversation trouvée")
                      ], -1)
                    ]))]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(conversationsList.value, (conversation, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: 'conv_' + index,
                        class: _normalizeClass(["text-grey-700 over-effect over-effect-scale", { 'bg-primary-50': (conversation.unreadCount || 0) > 0 || getUnreadCount(conversation.id) > 0 }]),
                        onClick: ($event: any) => (goToConversation(conversation.id))
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              (conversation.user?.avatar)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: conversation.user.avatar,
                                    class: "size-md rounded-100 mr-3",
                                    alt: ""
                                  }, null, 8, _hoisted_19))
                                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(conversation.user?.prenom?.[0] || 'U'), 1)
                                  ])),
                              ((conversation.unreadCount || 0) > 0 || getUnreadCount(conversation.id) > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString((conversation.unreadCount || getUnreadCount(conversation.id)) > 9 ? '9+' : (conversation.unreadCount || getUnreadCount(conversation.id))), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("h6", {
                                class: _normalizeClass(["mb-0", { 'font-bold': (conversation.unreadCount || 0) > 0 }])
                              }, _toDisplayString(conversation.user?.prenom) + " " + _toDisplayString(conversation.user?.nom), 3),
                              _createElementVNode("span", _hoisted_23, _toDisplayString(conversation.user?.email), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("h6", null, _toDisplayString(getTypeLabel(conversation.type)), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['badge', getStatutBadgeClass(conversation.statut)])
                          }, _toDisplayString(getStatutLabel(conversation.statut)), 3)
                        ]),
                        _createElementVNode("td", null, [
                          (conversation.dernierMessage)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("h6", {
                                  class: _normalizeClass(["mb-0 text-sm", { 'font-bold': (conversation.unreadCount || 0) > 0 }])
                                }, _toDisplayString(conversation.dernierMessage.texte.substring(0, 50)) + _toDisplayString(conversation.dernierMessage.texte.length > 50 ? '...' : ''), 3),
                                _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(formatDate)(conversation.dernierMessage.date)), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_26, "Aucun message"))
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("h6", null, [
                            _createTextVNode(_toDisplayString(conversation.messagesCount) + " ", 1),
                            ((conversation.unreadCount || 0) > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, " (" + _toDisplayString(conversation.unreadCount) + " non lu" + _toDisplayString((conversation.unreadCount || 0) > 1 ? 's' : '') + ") ", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("h6", null, _toDisplayString(_unref(formatDate)(conversation.updated_at)), 1)
                        ]),
                        _createElementVNode("td", {
                          class: "flex-right mt-1",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createElementVNode("button", {
                            class: "btn",
                            onClick: ($event: any) => (goToConversation(conversation.id))
                          }, [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("img", {
                              src: "/icons/icon-edit.svg",
                              class: "btn-icon",
                              alt: ""
                            }, null, -1),
                            _createElementVNode("span", null, "Ouvrir", -1)
                          ]))], 8, _hoisted_28)
                        ])
                      ], 10, _hoisted_16))
                    }), 128))
            ])
          ])
        ]),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
      ])
    ]),
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
  ]))
}
}

})